// extracted by mini-css-extract-plugin
export default {"controlesSwitch":"ControlesSwitch_controlesSwitch__ZLGsZ","controlesSwitch__leble":"ControlesSwitch_controlesSwitch__leble__vwwpN"};